import React from "react";
import {Row, Col, Button, Container} from 'reactstrap';
import ListGroupCollapse from "./ListGroupCollapse";
import './style.css'
import { Link } from 'react-router-dom';


class FAQ extends React.Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);

    this.state = {};
  }

  toggle(faq) {
    this.setState({ collapse: this.state.collapse === faq ? null : faq });
  }
  render() {
    const faqs = this.props.faqs;
    return (
    <div className="faq-page pt-5">

    <Container>
    <Row >
        <Col sm={{ size: 12 }} className='text-center '>
          <h1 style={{textAlign:'center'}} className='all-headers mt-5 pt-3 '>
            FAQs
          </h1>
        </Col>
      </Row>
    </Container>
     
      <Container className="py-4">
        <Row className='justify-content-center'>
          <Col sm={{ size: 10 }}>
            {Object.keys(faqs).map((key, index) => (
              <ListGroupCollapse
                  key={index}
                  prompt={faqs[key]}
                  isOpen={this.state.collapse === faqs[key]}
                  toggle={this.toggle}
                />
              ))}
          </Col>
        </Row>
        
      </Container>
      <Col className='bottom-contact-us text-center'>
            <h1 style={{textAlign:'center'}} className="white further mt-3 mb-3">Further Questions</h1>
            <Link to="./contact-us">
              <Button className="course-hero-start1 ">Contact Us</Button>
            </Link>
      </Col>
  
    </div>
    
    );
  }
}
export default FAQ;
